import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/device-command'

export const get = async (queryParam = {}) => {
    const params = {
        page: queryParam.page || undefined,
        limit: queryParam.limit || queryParam.size || undefined,
        sorts: queryParam.sorts?.length > 0 ? queryParam.sorts : undefined,
        search: queryParam.search || queryParam.q || undefined,
        filters: queryParam.filters || undefined,
    }

    const response = await apiClient({
        method: 'GET',
        url: baseEndpoint,
        params,
    })

    return response?.data
}

export const getByDeviceCodeSensorCodePinCode = async (deviceCode, sensorCode, pinCode) => {
    const response = await apiClient({
        method: 'GET',
        url: `${baseEndpoint}/${deviceCode}/${sensorCode}/${pinCode}`,
    })

    return response?.data
}
